var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.close,
          expression: "close"
        }
      ],
      staticClass: "c-dropdown",
      class: _vm.dropdownClasses,
      on: { click: _vm.toggle }
    },
    [
      _c(
        "div",
        { ref: "handle", staticClass: "c-dropdown__handle" },
        [_vm._t("handle", [_vm._v("\n            Actions\n        ")])],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "actions",
          staticClass: "c-dropdown__hidden",
          class: { hidden: !_vm.isOpen }
        },
        [
          _c(
            "ul",
            { staticClass: "c-dropdown__content" },
            [_vm._t("default")],
            2
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }